// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
    display: flex;
    flex-direction: row;
    height: var(--app-height, 100dvh);
    background-color: var(--color-bg);
    overflow: hidden;
}

.app__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    position: relative;
}

.app__agent_split {
    width: 100%;
    height: 100%;
}

.app__sections {
    position: relative;
    width: 100%;
    height: 100%;
}

.app__section {
    position: absolute;
    inset: 0;
    display: none;
}

.app__section[data-active="true"] {
    display: block;
}

.app__sections--slide .app__section {
    display: block;
    transform: translateX(calc((var(--section-index, 0) - var(--active-index, 0)) * 100%));
    --vkb-bottom: 0px;
}

.app__sections--slide[data-animated="true"] .app__section {
    transition: transform 0.15s ease;
}

.app__mobile_agent {
    position: absolute;
    inset: 0;
    z-index: 1050;
    transition: transform 0.15s ease;
}

.app__mobile_agent[data-visible="false"] {
    transform: translateX(100%);
    pointer-events: none;
}

@media (orientation: landscape) {
    .app__mobile_agent[data-visible="false"] {
        transform: translateY(-100%);
    }
}

.app[data-agent-open="false"] .app__agent_split > .react-split__sash {
    display: none;
}

.app__placeholder {
    padding: 35px;
    color: var(--color-text-muted);
    font-size: 14px;
}

@media (max-width: 845px) and (orientation: portrait) {
    .app {
        flex-direction: column;
    }

    .activity_bar {
        order: 2;
    }

    .app__content {
        order: 1;
    }
}

.app__loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--app-height, 100dvh);
    color: var(--color-text-muted);
    font-size: 14px;
    background-color: var(--color-bg);
}

.app__loading_spinner {
    display: block;
    width: 24px;
    height: 24px;
    border: 2px solid var(--color-border);
    border-top-color: var(--color-accent);
    border-radius: 50%;
    animation: app_spin 0.7s linear infinite;
}

@keyframes app_spin {
    to { transform: rotate(360deg); }
}

.auth_section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: var(--app-height, 100dvh);
    background-color: var(--color-bg);
}

.auth_section__tabs {
    display: flex;
    margin-bottom: 0;
    border-bottom: 1px solid var(--color-border);
    width: 352px;
}

.auth_section__tab {
    flex: 1;
    padding: 11px 0;
    color: var(--color-text-muted);
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    font-size: 14px;
    transition: color 0.1s, border-color 0.1s;
    margin-bottom: -1px;
}

@media (pointer: fine) {
    .auth_section__tab:hover {
        color: var(--color-text);
    }
}

.auth_section__tab.active {
    color: var(--color-text);
    border-bottom-color: var(--color-accent);
}
`, "",{"version":3,"sources":["webpack://./components/App/s.app.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,sFAAsF;IACtF,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,8BAA8B;IAC9B,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,qCAAqC;IACrC,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,4CAA4C;IAC5C,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,eAAe;IACf,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C","sourcesContent":[".app {\n    display: flex;\n    flex-direction: row;\n    height: var(--app-height, 100dvh);\n    background-color: var(--color-bg);\n    overflow: hidden;\n}\n\n.app__content {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    position: relative;\n}\n\n.app__agent_split {\n    width: 100%;\n    height: 100%;\n}\n\n.app__sections {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.app__section {\n    position: absolute;\n    inset: 0;\n    display: none;\n}\n\n.app__section[data-active=\"true\"] {\n    display: block;\n}\n\n.app__sections--slide .app__section {\n    display: block;\n    transform: translateX(calc((var(--section-index, 0) - var(--active-index, 0)) * 100%));\n    --vkb-bottom: 0px;\n}\n\n.app__sections--slide[data-animated=\"true\"] .app__section {\n    transition: transform 0.15s ease;\n}\n\n.app__mobile_agent {\n    position: absolute;\n    inset: 0;\n    z-index: 1050;\n    transition: transform 0.15s ease;\n}\n\n.app__mobile_agent[data-visible=\"false\"] {\n    transform: translateX(100%);\n    pointer-events: none;\n}\n\n@media (orientation: landscape) {\n    .app__mobile_agent[data-visible=\"false\"] {\n        transform: translateY(-100%);\n    }\n}\n\n.app[data-agent-open=\"false\"] .app__agent_split > .react-split__sash {\n    display: none;\n}\n\n.app__placeholder {\n    padding: 35px;\n    color: var(--color-text-muted);\n    font-size: 14px;\n}\n\n@media (max-width: 845px) and (orientation: portrait) {\n    .app {\n        flex-direction: column;\n    }\n\n    .activity_bar {\n        order: 2;\n    }\n\n    .app__content {\n        order: 1;\n    }\n}\n\n.app__loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: var(--app-height, 100dvh);\n    color: var(--color-text-muted);\n    font-size: 14px;\n    background-color: var(--color-bg);\n}\n\n.app__loading_spinner {\n    display: block;\n    width: 24px;\n    height: 24px;\n    border: 2px solid var(--color-border);\n    border-top-color: var(--color-accent);\n    border-radius: 50%;\n    animation: app_spin 0.7s linear infinite;\n}\n\n@keyframes app_spin {\n    to { transform: rotate(360deg); }\n}\n\n.auth_section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: var(--app-height, 100dvh);\n    background-color: var(--color-bg);\n}\n\n.auth_section__tabs {\n    display: flex;\n    margin-bottom: 0;\n    border-bottom: 1px solid var(--color-border);\n    width: 352px;\n}\n\n.auth_section__tab {\n    flex: 1;\n    padding: 11px 0;\n    color: var(--color-text-muted);\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    cursor: pointer;\n    font-size: 14px;\n    transition: color 0.1s, border-color 0.1s;\n    margin-bottom: -1px;\n}\n\n@media (pointer: fine) {\n    .auth_section__tab:hover {\n        color: var(--color-text);\n    }\n}\n\n.auth_section__tab.active {\n    color: var(--color-text);\n    border-bottom-color: var(--color-accent);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
